import React from 'react';

const FLAG_CODES = {
  '🇪🇸': 'es', '🇬🇧': 'gb', '🇫🇷': 'fr', '🇩🇪': 'de', '🇳🇱': 'nl',
  '🇧🇪': 'be', '🇵🇹': 'pt', '🇪🇺': 'eu',
  'ES': 'es', 'GB': 'gb', 'FR': 'fr', 'DE': 'de', 'NL': 'nl',
  'BE': 'be', 'PT': 'pt', 'EU': 'eu',
  'es': 'es', 'en': 'gb', 'fr': 'fr', 'de': 'de', 'nl': 'nl',
};

export const FlagImg = ({ code, size = 20, className = '' }) => {
  const isoCode = FLAG_CODES[code] || code?.toLowerCase();
  if (!isoCode) return null;

  return (
    <img
      src={`https://flagcdn.com/w40/${isoCode}.png`}
      srcSet={`https://flagcdn.com/w80/${isoCode}.png 2x`}
      alt={isoCode.toUpperCase()}
      width={size}
      height={Math.round(size * 0.75)}
      className={`inline-block ${className}`}
      style={{ objectFit: 'contain' }}
      loading="lazy"
    />
  );
};
